// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f192ab00","634":"a3784953","817":"f14bc57d"}[chunkId] + ".chunk.js";
};